import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FlightsContainer } from './components/flights-container/flights.container';
import {
  SearchBarMobileCalendarContainer
} from '@shared/base-search-bar/components/calendar/components/search-bar-mobile-calendar/search-bar-mobile-calendar.container';
import { productHomeRoute } from '@app/constants/app-routing.constants';

export const flightsRootRoute = 'flights';
export const calendarRoute = 'calendar';
const childrenCalendarRoute = {
  path: calendarRoute,
  outlet: 'search',
  component: SearchBarMobileCalendarContainer,
};
@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: productHomeRoute,
        component: FlightsContainer,
        children: [childrenCalendarRoute],
        data: {
          loadDefaultplaces: true,
        }
      },
      {
        path: `${productHomeRoute}/:flight_type/:flight_class/:departure/:arrival/:departure_date`
          + '/:arrival_date/:adults/:children/:infants/:baggage_included',
        component: FlightsContainer,
        children: [childrenCalendarRoute]
      },
      {
        path: `${productHomeRoute}/:flight_type/:flight_class/:departure/:arrival/:departure_date`
          + '/:adults/:children/:infants/:baggage_included',
        component: FlightsContainer,
        children: [childrenCalendarRoute]
      },
    ])
  ],
  exports: [RouterModule]
})
export class FlightsRoutingModule {

}
